import React from "react";
import UserList from "../../Components/UserList";

const EcosystemPartners = () => {
  return <UserList role="ecosystem_partner" roleLabel="Ecosystem Partners" />;
};

export default EcosystemPartners;
